import styled from '@emotion/styled';

import { Glyph } from '../common/Glyph';
import { HomeyIcon } from '../common/HomeyIcon';

import { publicUrl } from '../../theme/functions/publicUrl';
import { theme } from '../../theme/theme';

export function DeviceIcon({
  iconObj,
  iconUrl,
  iconOverride,
  size = '48px',
  color = theme.color.icon_dark,
  ...rest
}) {
  const url = getDeviceIconURL({
    iconUrl,
    iconOverride,
  });

  return (
    <Container {...rest}>
      {url != null ? (
        <Glyph source={url} size={size} color={color} />
      ) : (
        <HomeyIcon iconObj={iconObj} size={size} color={color} />
      )}
    </Container>
  );
}

export function getDeviceIconURL({ iconUrl, iconOverride }) {
  if (iconOverride != null) {
    return getOverrideURL({ iconOverride });
  }

  return iconUrl;
}

export function getOverrideURL({ iconOverride }) {
  return publicUrl(`img/devices/${iconOverride}.svg`);
}

const Container = styled.div`
  display: flex;
  align-items: center;
`;
